import { getAppText } from 'Utils/text';
import { CancellationReason, CancelSurveyReason } from './cancelForm.constants';

interface CancellationReasonOption {
  id: string;
  label: string;
  value: string;
}

interface CancelSurveyOptions extends CancellationReasonOption {}

export const getCancellationReasonOptions = (): CancellationReasonOption[] => [
  {
    id: CancellationReason.MOVE_TO_NEW_COMPANY,
    label: getAppText(
      'cancelInsurance.cancellationReasonOptions.moveToNewCompany.label',
    ),
    value: CancellationReason.MOVE_TO_NEW_COMPANY,
  },
  {
    id: CancellationReason.OBJECT_AT_RISK_NOT_EXIST_ANY_MORE,
    label: getAppText(
      'cancelInsurance.cancellationReasonOptions.notExists.label',
    ),
    value: CancellationReason.OBJECT_AT_RISK_NOT_EXIST_ANY_MORE,
  },
  {
    id: CancellationReason.YEARLY_RENEWAL,
    label: getAppText(
      'cancelInsurance.cancellationReasonOptions.yearlyRenewal.label',
    ),
    value: CancellationReason.YEARLY_RENEWAL,
  },
];

export const getCancelSurveyOptions = (): CancelSurveyOptions[] => [
  {
    id: CancelSurveyReason.TOO_EXPENSIVE,
    label: getAppText('cancelInsurance.cancelSurveyOptions.tooExpensive.label'),
    value: CancelSurveyReason.TOO_EXPENSIVE,
  },
  {
    id: CancelSurveyReason.NOT_NEEDED,
    label: getAppText('cancelInsurance.cancelSurveyOptions.notNeeded.label'),
    value: CancelSurveyReason.NOT_NEEDED,
  },
  {
    id: CancelSurveyReason.MOVED_TO_NEW_COMPANY,
    label: getAppText(
      'cancelInsurance.cancelSurveyOptions.movedToNewCompany.label',
    ),
    value: CancelSurveyReason.MOVED_TO_NEW_COMPANY,
  },
  {
    id: CancelSurveyReason.HEALTH_ASSESSMENT_RESULT,
    label: getAppText(
      'cancelInsurance.cancelSurveyOptions.healthAssessmentResult.label',
    ),
    value: CancelSurveyReason.HEALTH_ASSESSMENT_RESULT,
  },
  {
    id: CancelSurveyReason.OTHER_REASON,
    label: getAppText('cancelInsurance.cancelSurveyOptions.otherReason.label'),
    value: CancelSurveyReason.OTHER_REASON,
  },
];
